// src/services/apis/paymentApi.js

const paymentApi = (apiClient) => ({
  getCryptoDetails: async () => {
    const response = await apiClient.get('/Payment/Crypto/GetCryptoDetails');
    return response.data;
  },
});

export default paymentApi;
